module.exports = __webpack_public_path__ + "img/align-bottom.698995f1.svg";